import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import Services from "./pages/Services";
import Industries from "./pages/Industries";
import About from "./pages/About";
import Contact from "./pages/Contact";

import { AuthProvider } from "./portal/AuthContext";
import ProtectedRoute from "./portal/ProtectedRoute";
import PortalShell from "./portal/PortalShell";
import PortalLogin from "./portal/PortalLogin";
import PortalInbox from "./portal/PortalInbox";
import PortalCompose from "./portal/PortalCompose";
import PortalMailboxSetup from "./portal/PortalMailboxSetup";
import PortalAdmin from "./portal/PortalAdmin";

function PublicChrome({ children }) {
    const location = useLocation();
    const isPortal = location.pathname.startsWith("/portal");
    return (
        <>
            {!isPortal && <Navbar />}
            {children}
            {!isPortal && <Footer />}
        </>
    );
}

function App() {
    return (
        <div className="App relative">
            <BrowserRouter>
                <AuthProvider>
                    <PublicChrome>
                        <Routes>
                            {/* Public marketing site */}
                            <Route path="/" element={<Home />} />
                            <Route path="/services" element={<Services />} />
                            <Route path="/industries" element={<Industries />} />
                            <Route path="/about" element={<About />} />
                            <Route path="/contact" element={<Contact />} />

                            {/* Portal */}
                            <Route path="/portal/login" element={<PortalLogin />} />
                            <Route
                                path="/portal"
                                element={
                                    <ProtectedRoute>
                                        <PortalShell>
                                            <PortalInbox />
                                        </PortalShell>
                                    </ProtectedRoute>
                                }
                            />
                            <Route
                                path="/portal/compose"
                                element={
                                    <ProtectedRoute>
                                        <PortalShell>
                                            <PortalCompose />
                                        </PortalShell>
                                    </ProtectedRoute>
                                }
                            />
                            <Route
                                path="/portal/mailbox-setup"
                                element={
                                    <ProtectedRoute>
                                        <PortalShell>
                                            <PortalMailboxSetup />
                                        </PortalShell>
                                    </ProtectedRoute>
                                }
                            />
                            <Route
                                path="/portal/admin"
                                element={
                                    <ProtectedRoute adminOnly>
                                        <PortalShell>
                                            <PortalAdmin />
                                        </PortalShell>
                                    </ProtectedRoute>
                                }
                            />
                        </Routes>
                    </PublicChrome>
                </AuthProvider>
            </BrowserRouter>
            <Toaster
                position="bottom-right"
                theme="dark"
                toastOptions={{
                    style: {
                        background: "rgba(8,18,40,0.85)",
                        border: "1px solid rgba(59,130,246,0.25)",
                        color: "#F8FAFC",
                        backdropFilter: "blur(16px)",
                    },
                }}
            />
        </div>
    );
}

export default App;
